<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách chi hoa hồng</h1>
      <div class="float-right btn-group">
        <DraggableTable :naming="$route.name" v-model="fieldsTable" @change="filterTable = $event"/>
        <b-dropdown
          size="sm"
          text="Chọn hoạt động"
          variant="outline-light"
          v-if="selected.length > 0"
          class="pt-2 mr-2 btn btn-outline-light hc-37 m-b-10"
        >
          <button
            type="button"
            class="dropdown-item"
            @click="approveCommissions('APPROVED')"
          >
            <i class="bx bx-check-circle"></i><span>&nbsp;</span> Duyệt chi hoa hồng
          </button>
          <button
            type="button"
            class="dropdown-item"
            @click="showModalRejectAction = true"
          >
            <i class="bx bx-x-circle"></i><span>&nbsp;</span> Từ chối chi
          </button>
        </b-dropdown>
      </div>
    </div>
    <div class="p-10 card pt-15">
      <div class="card-header m-b-10">
        <form action="" class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              placeholder = "Thời gian tạo"
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label v-if="picker.startDate && picker.endDate" style="min-width: 13.5em" class="text-center font-size-12">
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="pt-1 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.agentInfo"
              class="form-control f12 hc-37 text-placeholder"
              placeholder="Tên/Email/SĐT Cộng tác viên"
            >
          </div>
          <div class="form-group">
            <Select2
              placeholder="Vùng kinh doanh"
              v-model="regionId"
              :options="dataConfigRegion"
              @change="queryProvince($event)">
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.cityCode"
              :options="dataProvince"
              placeholder="Tỉnh/Thành phố"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.agentGroup"
              :options="dataCtvType"
              placeholder="Loại cộng tác viên"
            ></Select2>
          </div>
          <!-- <div class="form-group">
            <Select2
              v-model="search.agentInfo"
              :options="dataCollaborators"
              placeholder="Cộng tác viên"
            ></Select2>
          </div> -->
          <div class="form-group">
            <Select2
              v-model="search.state"
              :options="dataStatus"
              placeholder="Trạng thái"
            ></Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              class="pt-2 mr-2 btn btn-primary hc-37"
              @click="submitForm($event)"
              data-toggle="tooltip"
              data-placement="top"
            >
              <i class="bx bx-filter-alt"></i>&nbsp; Lọc
            </button>
            <button
              class="pt-2 mr-2 btn btn-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              @click="removeForm()"
            >
              <i class="bx bx-filter-alt"></i>&nbsp; Bỏ lọc
            </button>
          </div>
        </form>

        </div>

      <div class="card-body">
        <div class="tab-content">
          <div class="box-header">
            <span>
              Tổng:
              <strong class="text-primary">
                {{ dataCountCommissions.total ? dataCountCommissions.total : 0 }}
              </strong> &nbsp; |
            </span>
            <span>
              Chờ chi:
              <strong class="text-primary">
                {{ dataCountCommissions.totalWaiting ? dataCountCommissions.totalWaiting : 0 }}
              </strong> &nbsp; |
            </span>
            <span>
              Đã chi:
              <strong class="text-primary">
                {{ dataCountCommissions.totalApproved ? dataCountCommissions.totalApproved : 0 }}
              </strong> &nbsp; |
            </span>
            <span>
              Từ chối chi:
              <strong class="text-primary">
                {{ dataCountCommissions.totalRejected ? dataCountCommissions.totalRejected : 0 }}
              </strong>
            </span>
            <span class="float-right">

            </span>
          </div>
          <div class="p-10">
            <b-table :busy.sync="loading" sticky-header hover responsive :items="dataHistoryCommissions" :fields="filterTable" :fixed="true" :bordered="true">
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #head(selected)>
                <b-form-checkbox class="text-center" v-model="selectAll"></b-form-checkbox>
              </template>
              <template #cell(selected)="data">
                 <b-form-checkbox
                    class="text-center"
                    v-model="selected"
                    :value="data.item.id"
                    :disabled="data.item.status !== 'WAITING'">
                  </b-form-checkbox>
              </template>
              <template #cell(merchant)="data">
                <p>{{ data.item.customerInfo.merchantName }}</p>
                <p>{{ data.item.customerInfo.mobile }}</p>
                <p>{{ data.item.customerInfo.agentGroup }}</p>
              </template>
              <template #cell(agentName)="data">
                <p>{{ data.item.agentInfo.name }}</p>
                <p>{{ data.item.agentInfo.mobile }}</p>
              </template>
              <template #cell(agent)="data">
                <p>{{ data.item.agentInfo.agentGroup }}</p>
              </template>
              <template #cell(dateCreate)="data">
                <p>{{ data.item.dateCreate | formatDate('HH:mm, DD/MM/YYYY') }}</p>
              </template>
              <template #cell(approvedBy)="data">
                <p>{{ data.item.approvedBy }}</p>
                <p v-if="data.item.dateEdit">{{ data.item.dateEdit | formatDate('HH:mm, DD/MM/YYYY') }}</p>
              </template>
              <template #cell(status)="data">
                <span
                  class="badge" :class="[data.item.status ? data.item.status : '']">{{ data.item.status | mapTextStatus(dataStatus)  }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown v-if="data.item.status === 'WAITING'" class="text-center" variant="outline-light">
                  <button class="dropdown-item"
                    @click="approveCommissions('APPROVED', data.item.id)">
                    <i class="bx bx-check-circle"></i><span>&nbsp;</span> Duyệt chi
                  </button>
                  <button class="dropdown-item"
                    @click="rejectCommissions(data.item.id)">
                    <i class="bx bx-x-circle"></i><span>&nbsp;</span> Từ chối chi
                  </button>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="mr-2 fl-right"
          >
          </b-pagination>
        </div>
      </div>
    </div>

    <div v-if="showModalRejectAction">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                    Lý do từ chối
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="showModalRejectAction = false"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="text-center modal-body">
                  <form>
                    <div class="form-group pos-relative">
                      <textarea
                        v-model="reasonRejectedAction"
                        class="form-control f12"
                      ></textarea>
                    </div>
                  </form>
                </div>
                <div class="modal-footer">
                  <button
                    class="btn btn-success"
                    :disabled="reasonRejectedAction && reasonRejectedAction !== '' &&
                      (reasonRejectedAction.length < 2 || reasonRejectedAction.length > 255)"
                    type="button"
                    @click="submitRejectReason()"
                  >
                    Xác nhận
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <NotiSuccess
      :showModalSuccess="showModalSuccess"
      :messSuccess="messNoti"
      @close="showModalSuccess = false"
    >
    </NotiSuccess>

    <NotiError
      :showModalErr="showModalErr"
      :messErr="messNoti"
      @close="showModalErr = false"
    >
    </NotiError>

    <VueLoadingOverlay :active.sync="showLoading"
        :is-full-page="true">
    </VueLoadingOverlay>

  </div>
</template>

<script>
import Config from '@/thirdParty/config'
import { StaffService } from '@/services/staff.service'
import { AgentService } from '@/services/agent.service'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { ContractService } from '../../services/contract.service'
const fieldsTable = [
  { key: 'selected' },
  { key: 'merchant', label: 'Merchant' },
  { key: 'contractCode', label: 'Mã HĐ/PL' },
  { key: 'agentName', label: 'Cộng tác viên' },
  { key: 'agent', label: 'Loại CTV' },
  { key: 'dateCreate', label: 'Thời gian tạo' },
  { key: 'approvedBy', label: 'Người duyệt/Từ chối chi' },
  { key: 'status', label: 'Trạng thái' },
  { key: 'reasonReject', label: 'Lý do từ chối' },
  { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' }
]
export default {
  data () {
    return {
      fieldsTable,
      filterTable: fieldsTable,
      dataUser: JSON.parse(localStorage.getItem('userData')),
      loading: false,
      search: {
        limit: 20,
        page: 1
      },
      regionId: null,
      pagination: {
        total: 0
      },
      dataHistoryCommissions: [],
      dataCountCommissions: {},
      localeData: Config.localeData,
      dateRange: {
        startDate: null,
        endDate: null
      },
      dataComission: [],
      selected: [],
      dataConfigRegion: [],
      dataProvince: [],
      dataCtvType: [
        { id: '0', text: 'Tất cả' },
        { id: 'MSB', text: 'MSB' },
        { id: 'NEXTPAY', text: 'NEXTPAY' },
        { id: 'SAPO', text: 'SAPO' },
        { id: 'POSAPP', text: 'POSAPP' }
      ],
      dataCollaborators: [],
      dataStatus: [
        { id: '0', text: 'Tất cả' },
        { id: 'APPROVED', text: 'Đã chi' },
        { id: 'REJECTED', text: 'Từ chối' },
        { id: 'WAITING', text: 'Chờ chi' }
      ],
      reasonRejectedAction: '',
      showModalRejectAction: false,
      showModalSuccess: false,
      showModalErr: false,
      messNoti: null,
      commissionSelected: '',
      showLoading: false
    }
  },

  created () {
    this.getRegions()
    // this.getListCTV()
    this.fetchData()
  },

  watch: {
    'search.page': function () {
      this.$router.replace({
        query: this.useInUrlQueryPropList
      })
      this.fetchData()
    }
  },

  computed: {
    ...mapGetters({
      dataPermission: 'role/dataPermission'
    }),
    useInUrlQueryPropList () {
      return this.prepareQueryParamsMixin({
        limit: this.search.limit,
        page: this.search.page
      })
    },
    selectAll: {
      get: function () {
        return this.dataHistoryCommissions ? this.selected.length === this.dataHistoryCommissions.length : false
      },
      set: function (value) {
        var selected = []
        if (value) {
          this.dataHistoryCommissions.forEach(function (item) {
            if (item.status === 'WAITING') selected.push(item.id)
          })
        }
        this.selected = selected
      }
    }
  },

  methods: {
    async getRegions () {
      const dataRes = await StaffService.getRegions()
      if (dataRes.data.length > 0) {
        const dataRegion = [
          {
            id: 0,
            text: 'Tất cả'
          }
        ]
        dataRes.data.map((e) => {
          dataRegion.push({ id: e.id, text: e.name })
        })
        this.dataConfigRegion = dataRegion
      }
    },

    async queryProvince (e) {
      try {
        const data = await StaffService.getProvinceRegion({ regionId: [e] })
        if (data.data.length > 0) {
          const dataProvince = [
            {
              id: 0,
              text: 'Tất cả'
            }
          ]
          data.data.map((e) => {
            const body = {
              id: e.code,
              text: e.name
            }
            dataProvince.push(body)
          })
          this.dataProvince = dataProvince
          return
        }
        this.dataProvince = []
      } catch (error) {}
    },

    async getListCTV () {
      try {
        const dataItem = await AgentService.listAgentByUser({
          userId: this.dataUser.userId
        })
        if (dataItem.success) {
          this.dataCollaborators = [{ id: 0, text: 'Tất cả' }]
          dataItem.data.map((e) => {
            this.dataCollaborators.push({ id: e.agentId, text: e.name })
          })
        }
      } catch (error) {
        console.log(error)
      }
    },

    async submitForm (event) {
      event.preventDefault()
      this.search.page = 1
      this.fetchData()
    },

    async removeForm () {
      this.search = {
        limit: 20,
        page: 1
      }
      this.regionId = null
      this.dateRange = {
        startDate: null,
        endDate: null
      }
      this.selected = []
      await this.fetchData()
    },

    transformDate () {
      this.search.dateFrom = moment(this.dateRange.startDate)
        .startOf('day')
        .add(7, 'hours')
        .valueOf()
      this.search.dateTo = moment(this.dateRange.endDate)
        .endOf('day')
        .add(7, 'hours')
        .valueOf()
    },

    async approveCommissions (typeAction, commissionId) {
      try {
        this.showLoading = true
        const body = {
          collaboratorIdList: (commissionId && commissionId !== '') ? [commissionId] : this.selected,
          action: typeAction
        }
        if (typeAction === 'REJECTED') body.reasonReject = this.reasonRejectedAction
        const response = await ContractService.actionApproveCommission(body)
        if (response.code === 1000) {
          this.showLoading = false
          this.showModalSuccess = true
          this.messNoti = response.message
          await this.fetchData()
        } else {
          this.showModalErr = true
          this.messNoti = response.message
          this.loading = false
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.showLoading = false
      }
    },

    async submitRejectReason () {
      this.showModalRejectAction = false
      if (this.commissionSelected !== '') await this.approveCommissions('REJECTED', this.commissionSelected)
      else await this.approveCommissions('REJECTED')
      this.reasonRejectedAction = ''
    },

    rejectCommissions (item) {
      this.showModalRejectAction = true
      this.commissionSelected = item
    },

    async fetchData () {
      try {
        this.loading = true
        if (this.regionId !== null && this.regionId !== '0') this.search.regions = [this.regionId]
        if (this.search.cityCode === '0') delete this.search.cityCode
        if (this.search.agentGroup === '0') delete this.search.agentGroup
        if (this.search.agentId === '0') delete this.search.agentId
        if (this.search.state === '0') delete this.search.state
        const response = await AgentService.getHistoryCommissions(this.search)
        if (response.code === 1000) {
          this.dataHistoryCommissions = response.data.collaborators
          this.dataCountCommissions = response.data.countCollaborator ? response.data.countCollaborator : {}
          this.pagination.total = this.dataCountCommissions.total ? this.dataCountCommissions.total : 0
        } else {
          console.log(response)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
        this.selected = []
      }
    }
  }

}
</script>

<style scoped>
.time-placeholder, .text-placeholder::placeholder {
  color: #999 !important;
}

</style>
